import { render } from "./EditFarmacia.vue?vue&type=template&id=9e4affa6"
import script from "./EditFarmacia.vue?vue&type=script&lang=js"
export * from "./EditFarmacia.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__